/** @public */
export enum SynchronizationStatus {
  inProgress = 'inProgress',
  done = 'done',
}
